import EmailContentEditor from './email-content-editor';

export default EmailContentEditor;
